export const pathLogin = "/";
export const pathHome = "/home";
export const pathPublicationPrice = "/publication-price";
export const pathInventory = "/inventory";
export const pathSupport = "/support";
